/* eslint-disable react/prop-types */
import React from "react";
import propTypes from "prop-types";
import MaterialTable, { MTableToolbar } from "material-table";
import { TextField } from "@material-ui/core";

// import useStyles from "./stylesTableDirecciones";

const headerStyle = {
  // color: "#FFEBD1",
  // backgroundColor: "#FFFFFA"
  fontSize: "17px",
  overflow: "visible"
};

const columns = [
  { title: "Nombre", field: "nombre", headerStyle },
  {
    title: "Correo",
    field: "correo",
    headerStyle,
    // eslint-disable-next-line react/display-name
    editComponent: ({ rowData, onChange }) => (
      <TextField
        type="email"
        // eslint-disable-next-line react/prop-types
        value={rowData.correo}
        onChange={e => onChange(e.target.value)}
        placeholder="alguien@ejemplo.com"
        styles={{ zIndex: 999 }}
      />
    )
  },
  {
    title: "Teléfono",
    field: "telefono",
    headerStyle,
    // eslint-disable-next-line react/display-name
    editComponent: ({ rowData, onChange }) => (
      <TextField
        type="tel"
        // eslint-disable-next-line react/prop-types

        onChange={e => onChange(e.target.value)}
        // eslint-disable-next-line react/prop-types
        value={rowData.telefono}
        placeholder="Teléfono"
        styles={{ zIndex: 999 }}
      />
    )
  },
  {
    title: "Empresa",
    field: "empresa",
    headerStyle,
    // eslint-disable-next-line react/display-name
    editComponent: ({ rowData, onChange }) => (
      <TextField
        type="Text"
        onChange={e => onChange(e.target.value)}
        // eslint-disable-next-line react/prop-types
        value={rowData.empresa}
        placeholder="Empresa"
        styles={{ zIndex: 999 }}
      />
    )
  }
];

const TableDestinatarios = ({
  data = [],
  onAdd = () => {},
  onUpdate = () => {},
  onDelete = () => {}
}) => {
  // const classes = useStyles();
  return (
    <MaterialTable
      style={{ width: "100%" }}
      title="Paquetes"
      options={{
        exportButton: true
      }}
      components={{
        // eslint-disable-next-line react/display-name
        Toolbar: props => <MTableToolbar {...props} />
      }}
      localization={{
        body: {
          emptyDataSourceMessage: "Sin datos para mostrar",
          addTooltip: "Agregar",
          deleteTooltip: "Borrar",
          editTooltip: "Editar",
          filterRow: {
            filterTooltip: "Filtrar"
          },
          editRow: {
            deleteText: "Seguro que quieres borrar este registro?",
            cancelTooltip: "Cancelar",
            saveTooltip: "Guardar"
          }
        },
        header: {
          actions: ""
        },
        pagination: {
          labelDisplayedRows: "{from}-{to} de {count}",
          labelRowsPerPage: "Registros por página",
          labelRowsSelect: "registros",
          firstAriaLabel: "Primera página",
          firstTooltip: "Primera página",
          previousAriaLabel: "Anterior",
          previousTooltip: "Anterior",
          nextAriaLabel: "Siguiente",
          nextTooltip: "Siguiente",
          lastAriaLabel: "Último",
          lastTooltip: "Último"
        },
        toolbar: {
          exportTitle: "Exportar",
          exportAriaLabel: "Exportar",
          exportName: "Exportar como CSV",
          searchTooltip: "Buscar",
          searchPlaceholder: "Buscar"
        }
      }}
      columns={columns}
      data={data}
      editable={{
        onRowAdd: newData =>
          new Promise(resolve => {
            // console.log(newData);
            setTimeout(() => {
              onAdd(newData);

              resolve();
            }, 1000);
          }),
        onRowUpdate: newData =>
          new Promise(resolve => {
            // console.log(newData);
            setTimeout(() => {
              onUpdate(newData);
              resolve();
            }, 1000);
          }),
        onRowDelete: oldData =>
          new Promise(resolve => {
            setTimeout(() => {
              onDelete(oldData);
              resolve();
            }, 1000);
          })
      }}
    />
  );
};

TableDestinatarios.propTypes = {
  data: propTypes.array,
  onAdd: propTypes.func,
  onUpdate: propTypes.func,
  onDelete: propTypes.func
};

export default TableDestinatarios;
